/**
 * Provide/Inject 键，用于 Modal 与 Dropdown 等浮层组件的层级协调
 * Modal 提供 context，Dropdown inject 后自动使用更高 z-index 显示在 Modal 之上
 */
export const MODAL_LAYER_CONTEXT_KEY = Symbol('xModalLayerContext');
